import React from 'react';
import { Button, Card, Text } from '@fragments';
import {
    IconChevronDown,
    IconChartPie,
    IconDots,
    IconReceipt,
    IconShoppingBag,
} from '@tabler/icons-react';

const CATEGORIES = [
    { label: 'Shopping', amount: '$900.00', Icon: IconShoppingBag, tone: 'primary' },
    { label: 'Utilities', amount: '$600.00', Icon: IconReceipt, tone: 'info' },
    { label: 'Others', amount: '$900.00', Icon: IconDots, tone: 'muted' },
];

export default function SpendingSummary() {
    return (
        <Card
            flat
            headerDivider
            title="Spending Summary"
            icon={<IconChartPie />}
            action={
                <Button variant="text" color="inverse" size="small" endIcon={<IconChevronDown />}>
                    Last Year
                </Button>
            }
        >
            <div className="spending-summary">
                <div className="spending-summary__gauge" aria-label="Spend $1,800.00">
                    <svg viewBox="0 0 220 122" role="img">
                        <path className="spending-summary__arc spending-summary__arc--track" d="M24 110a86 86 0 0 1 172 0" />
                        <path className="spending-summary__arc spending-summary__arc--primary" d="M24 110a86 86 0 0 1 88 -82" />
                        <path className="spending-summary__arc spending-summary__arc--info" d="M112 28a86 86 0 0 1 62 26" />
                    </svg>
                    <div className="spending-summary__gauge-copy">
                        <Text.subheading contrast={6}>Spend</Text.subheading>
                        <Text.h3 weight={500} contrast={10}>$1,800.00</Text.h3>
                    </div>
                </div>

                <div className="spending-summary__categories">
                    {CATEGORIES.map(({ label, amount, Icon, tone }) => (
                        <div className="spending-summary__category" key={label}>
                            <span className={`spending-summary__icon spending-summary__icon--${tone}`}>
                                <Icon />
                            </span>
                            <Text.caption contrast={6}>{label}</Text.caption>
                            <Text.label contrast={9}>{amount}</Text.label>
                        </div>
                    ))}
                </div>

                <div className="spending-summary__note">
                    <Text.caption contrast={6} grow maxLines={1}>Your weekly spending limit is $2000.</Text.caption>
                    <span className="spending-summary__note-dot" aria-hidden="true" />
                </div>
            </div>
        </Card>
    );
}
